<template>
  <div class="scorm-completed">
    <h1>Course Completed</h1>
    <p>Please close this window and return to your Community to view your earned CEU’s and Certificates.</p>
  </div>
</template>

<script>
export default {
  name: "ScormCompleted"
};
</script>

<style scoped>
.scorm-completed {
  text-align: center;
  margin-top: 50px;
  font-size: 18px;
}
</style>
<template>
  <div class="scorm-completed">
    <h1>Course Completed</h1>
    <p>Please close this window and return to your Community to view your earned CEU’s and Certificates.</p>
  </div>
</template>

<script>
export default {
  name: "ScormCompleted"
};
</script>

<style scoped>
.scorm-completed {
  text-align: center;
  margin-top: 50px;
  font-size: 18px;
}
</style>
